import { Button, Icon } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { NON_EDITABLE_AUTOMATION_STATUS } from '@hero/constants';
import { DetailItem } from '@hero/molecules';
import { BasicContactTable, ContactsEditModal } from '@hero/organisms';
import { formatNumber } from '@hero/utils';

function WithContacts({ automation, onUpdate }) {
  const { code } = useParams();
  const { t } = useTranslation();

  const [isContactsEditModalOpen, setIsContactsEditModalOpen] = useState(false);
  const contacts = automation?.contacts;
  const isDetailItemEditable = React.useMemo(
    () => !NON_EDITABLE_AUTOMATION_STATUS.includes(automation?.status),
    [automation]
  );

  return (
    <>
      <DetailItem title={`${t('recipients')}:`} className="item-d-flex">
        {formatNumber(contacts?.ids?.length)}
        {isDetailItemEditable && (
          <Button
            variant="link"
            onClick={() => {
              setIsContactsEditModalOpen(true);
            }}
          >
            <Icon name="edit" px={14} color="var(--color-accent-primary-default)" />
            {t('editRecipientList')}
          </Button>
        )}
      </DetailItem>

      {contacts?.ids?.length > 0 && (
        <BasicContactTable
          ids={contacts?.ids || []}
          disabledColumns={[automation?.type === 'birthday' ? 'anniversary' : 'birthday']}
        />
      )}

      <ContactsEditModal
        isModalOpen={isContactsEditModalOpen}
        onRequestClose={() => setIsContactsEditModalOpen(false)}
        selectedContactIds={contacts?.ids || []}
        disabledColumns={[automation?.type === 'birthday' ? 'anniversary' : 'birthday']}
        featureType="automation"
        updateContacts={data => {
          onUpdate({
            params: { code },
            body: {
              contacts: {
                tags: [],
                ids: data
              }
            }
          });
        }}
      />
    </>
  );
}

WithContacts.propTypes = PropTypes.shape({
  automation: PropTypes.object,
  onUpdate: PropTypes.func
});

export { WithContacts };
